/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileTagsIn
 */
export interface FileTagsIn {
    /**
     * 
     * @type {Array<string>}
     * @memberof FileTagsIn
     */
    fileTags: Array<string>;
}

export function FileTagsInFromJSON(json: any): FileTagsIn {
    return FileTagsInFromJSONTyped(json, false);
}

export function FileTagsInFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileTagsIn {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileTags': json['fileTags'],
    };
}

export function FileTagsInToJSON(value?: FileTagsIn | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileTags': value.fileTags,
    };
}


